document.querySelector(".popup2-btn").addEventListener('click', function (e) {
e.stopPropagation();
document.querySelector(".popup2").style.display = 'block';
}, false);
document.querySelector(".popup2-btn").addEventListener('click', function () {
document.querySelector(".popup2-overlay").style.display = 'block';
}, false);
document.querySelector(".popup2-close").addEventListener('click', function () {
document.querySelector(".popup2").style.display = 'none';
document.querySelector(".popup2-overlay").style.display = 'none';
}, false);
document.querySelector("body").addEventListener('click', function () {
document.querySelector(".popup2").style.display = 'none';
document.querySelector(".popup2-overlay").style.display = 'none';
}, false);
document.querySelector(".popup2").addEventListener('click', function (e) {
e.stopPropagation();
}, false);
